import { Button } from "antd";
import { useTranslation } from "react-i18next";

const SubmitButton = ({ disabled, loading, onClick }) => {
  const { t } = useTranslation();

  return (
    <div className="p-5 fixed  bottom-0  w-full  max-w-2xl bg-white">
      <Button
        block
        className={`${
          disabled ? "disabled-button-large" : "primary-button-large"
        } justify-center items-center`}
        disabled={disabled}
        loading={loading}
        onClick={() => onClick()}
      >
        {t("card-page.choose-address")}
      </Button>
    </div>
  );
};
export default SubmitButton;
